import { PropsWithChildren } from "react";

import { Dialog } from "@fronterahealth/frontera-ui-components";

import { DialogTab } from "@pages/VideoAnalytics/components/DialogTab";

interface GraphRawDataDialogProps extends PropsWithChildren {
  title: string;
  open: boolean;
  setOpen: (val: boolean) => void;
}

export const GraphRawDataDialog: React.FC<GraphRawDataDialogProps> = ({ title, open, setOpen, children }) => {
  return (
    <Dialog
      size="7xl"
      title={title}
      open={open}
      setOpen={setOpen}
      primaryButton={undefined}
      secondaryButton={undefined}
      bodyClassName="max-h-[80vh]!"
      overflowBehavior="scroll"
    >
      <div className="flex flex-col gap-4">
        <DialogTab />
        {children}
      </div>
    </Dialog>
  );
};
